import React from 'react';

import { RefundContent } from '../content/refundContent';
import LegalPageLayout from '../layouts/LegalPageLayout';

export default function RefundPolicy() {
  return (
    <LegalPageLayout title="Cancellation / Refund Policy">
      <RefundContent />
    </LegalPageLayout>
  );
}
